import { render, staticRenderFns } from "./ExportBaseTabComponent.vue?vue&type=template&id=18431716&scoped=true"
import script from "./ExportBaseTabComponent.vue?vue&type=script&lang=js"
export * from "./ExportBaseTabComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18431716",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18431716')) {
      api.createRecord('18431716', component.options)
    } else {
      api.reload('18431716', component.options)
    }
    module.hot.accept("./ExportBaseTabComponent.vue?vue&type=template&id=18431716&scoped=true", function () {
      api.rerender('18431716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/ExportBaseTabComponent.vue"
export default component.exports